import Types from "@Types";

const reducer = (state = [], action) => {
    switch (action.type) {
        //? inset Customer
        case Types.Notification.insert:
            return [...state, action.payload.value];
        //? update Customer
        case "AddNotification":
            return [...state, action.payload]
        case "DeleteAllNotification":
            return []
        case Types.Notification.update:
            return [
                ...state.map((x) => {
                    if (x.Series === action.payload.Series) return action.payload.value;
                    else return x;
                }),
            ];
        //? delete Customer
        case Types.Notification.delete:
            return [...state.filter((x) => x.Series !== action.payload.Series)];
        // ? clear all data
        case Types.clear:
            return [];
        //? set Customer
        case Types.Notification.set:
            return action.payload.rows ?? [];
        // ? default
        default:
            return state;
    }
};

export default reducer;
